// extracted by mini-css-extract-plugin
export default {"EmptyBox":"EmptyBox_EmptyBox__1vvdQ"};